import { FormIdentity } from "../../../../common-components/common-form/common-form.model";
import '../../../../../iconlist';
export const familyColDefs = [
    { header: 'Name', field: 'firstName', type: 'leftAligned', style: '' },
    { header: 'Relation', field: 'relation', type: 'leftAligned', style: '' },
    { header: 'Gender', field: 'gender', type: 'leftAligned', style: '' },
    { header: 'Contact', field: 'contact', type: 'leftAligned', style: '' },
    { header: 'Email', field: 'email', type: 'leftAligned', style: '' },
    { header: 'Action', field: 'action', type: 'leftAligned', style: '', columnType: 'icon' }
];

export const coApplicantColDefs = [
    { header: 'Name', field: 'firstName', type: 'leftAligned', style: '' },
    { header: 'Relation', field: 'relation', type: 'leftAligned', style: '' },
    { header: 'Gender', field: 'gender', type: 'leftAligned', style: '' },
    { header: 'Contact', field: 'contact', type: 'leftAligned', style: '' },
    { header: 'Email', field: 'email', type: 'leftAligned', style: '' },
    {
        header: 'Action', field: 'action', type: 'leftAligned', style: '', columnType: 'icon'
    }
]
export const nomineeColDefs = [
    { header: 'Name', field: 'firstName', type: 'leftAligned', style: '' },
    { header: 'Relation', field: 'relation', type: 'leftAligned', style: '' },
    { header: 'Gender', field: 'gender', type: 'leftAligned', style: '' },
    { header: 'Contact', field: 'contact', type: 'leftAligned', style: '' },
    { header: 'Email', field: 'email', type: 'leftAligned', style: '' },
    { header: 'Action', field: 'action', type: 'leftAligned', style: '', columnType: 'icon' }
]

export const otherChargesColDefs = [
    { header: 'Name', field: 'name', type: 'leftAligned', style: '', columnType: 'text' },
    { header: 'Amount', field: 'amount', type: 'leftAligned', style: '', columnType: 'amount', config: { 'decimals': 0 } },
    { header: 'Discount', field: 'discount', type: 'leftAligned', style: '', columnType: 'amount', config: { 'decimals': 0 } },
    { header: 'CGST', field: 'cgst', type: 'leftAligned', style: '', columnType: 'amount', config: { 'decimals': 0 } },
    { header: 'SGST', field: 'sgst', type: 'leftAligned', style: '', columnType: 'amount' },
    { header: 'IGST', field: 'igst', type: 'leftAligned', style: '', columnType: 'amount', config: { 'decimals': 0 } },
    { header: 'Total Amount', field: 'totalAmount', type: 'leftAligned', style: '', columnType: 'amount', config: { 'decimals': 0 } },
    { header: 'Action', field: 'action', type: 'leftAligned', style: '', columnType: 'icon' }
]

export const paymentSchedule = [
    {
        header: 'Sr. No.', field: 'serialNumber', type: 'leftAligned', style: '', columnType: 'text'
    },
    {
        header: 'Payment Stage', field: 'stage', type: 'leftAligned', style: '', columnType: 'text'
    },
    { header: 'Amount', field: 'amount', type: 'leftAligned', style: '', columnType: 'amount', config: { 'decimals': 0 } },
    { header: 'Date', field: 'date', type: 'leftAligned', style: '', columnType: 'date' },
    { header: 'Action', field: 'action', type: 'leftAligned', style: '', columnType: 'image' },

]

export const referenceList = [
    // { value: "crmRef", label: "CRM Reference" },
    { value: "bookingRef", label: "Booking Reference" },
    { value: "newCustomer", label: "New Customer" }
];

export enum References {
    crmRef = "crmRef",
    bookingRef = "bookingRef",
    newCustomer = "newCustomer"
}

export interface IFormInfo {
    formIdentity: FormIdentity,
    formData: any
}

export interface IAllotment {
    referenceNumber?: number;
    clientId?: number;
    crmRefLeadId?: number;
    sourceId?: number;
    sourceTypeId?: number;
    unitCategoryId?: number;
    customerDetails?: ICustomerDetail;
    contactNumber?: string;
    SecondaryPhoneNo?: string;
    alternateEmail?: string;
    WeddingAnniversary?: string;
    bookingDate?: string;
    allotmentDate?: string;
    companyName?: string;
    officeAddress?: string;
    natureOfBusiness?: string;
    gstNumber?: string;
    emergencyDetails?: IEmergencyDetail,
    noimineeDetails?: INomineeDetail,
    firmDetails?: IFirmDetail;
    familyMemberDetails?: IFamilyMemberDetail[];
    coApplicantDetails?: ICustomerDetail[];
    nomineeDetails?: INomineeDetail[];
    paymentDetails?: IPaymentDetail;
}

export interface IEmergencyDetail {
    emergencyName: string;
    emergencyContactNumber: string;
    emergencyRelation: string;
}

export interface IFirmDetail {
    firmName: string;
    ffirmAddress: string;
    natureOfFirm: string;
    gst: string;
}

export interface IFamilyMemberDetail {
    firstName: string;
    lastName: string;
    contactNumber: string;
    email: string;
    dob: string;
    relation: string;
    gender: string;
    uidType: string;
    uidNumber: number;
    bloodGroup: string;
    pic: string;
    picExtn: string;
}

export interface ICustomerDetail {
    firstName: string;
    lastName: string;
    contactNumber: string;
    email: string;
    dob: string;
    relation: string;
    gender: string;
    uidType: string;
    uidNumber: number;
    bloodGroup: string;
    pic: string;
    picExtn: string;
    weddingAnniversary: Date;
}

export interface INomineeDetail {
    firstName: string;
    lastName: string;
    contactNumber: string;
    email: string;
    dob: string;
    relation: string;
    gender: string;
    uidType: string;
    uidNumber: number
    bloodGroup: string;
    pic: string;
    picExtn: string;
}

export interface IPaymentDetail {
    saleRate: string;
    taxStructure: string;
    paymentPlanId: string;
    paymentSchedule: IPaymentSchedule[];
    otherCharges: any[];
}

export interface IPaymentPlan {
    label: string;
    value: string;
    id: number;
}

export interface IPaymentSchedule {
    name: string;
    stageOrder: string;
    dueInDays: string;
    amountPercentage: string;
    isActive: boolean;
}

export const summaryColumnDefs = [
    {
        field: 'heads', header: 'Heads'
    },
    {
        field: 'atRate', header: 'At Rate'
    },
    {
        field: 'totalAmount', header: 'Total Amount'
    }
];

export const otherChargesColumnDefs = [
    {
        field: 'otherCharges', header: 'Other Charges'
    },
    {
        field: 'amount', header: 'Amount'
    },
    {
        field: 'discount', header: 'Amount'
    },
    {
        field: 'cgst', header: 'CGST'
    },
    {
        field: 'sgst', header: 'SGST'
    },
    {
        field: 'igst', header: 'IGST'
    },
    {
        field: 'totalAmount', header: 'Total Amount'
    }
]

export const summaryData = [
    {
        data: {
            heads: 'Basic Amount',
            atRate: '',
            totalAmount: '70,00,000'
        },
        children: [
            {
                data: {
                    heads: 'Gross Amount',
                    atRate: 200,
                    totalAmount: '70,00,000'
                },
                leaf: true
            },
            {
                data: {
                    heads: 'Discount',
                    atRate: '0.00',
                    totalAmount: '0.00'
                },
                leaf: true
            },
            {
                data: {
                    heads: 'Taxable Value',
                    atRate: '0.00',
                    totalAmount: '70,00,000'
                },
                leaf: true
            },
            {
                data: {
                    heads: 'CGST',
                    atRate: '0.00',
                    totalAmount: '0.00'
                },
                leaf: true
            },
            {
                data: {
                    heads: 'SGST',
                    atRate: '0.00',
                    totalAmount: '0.00'
                },
                leaf: true
            },
            {
                data: {
                    heads: 'IGST',
                    atRate: '0.00',
                    totalAmount: '0.00'
                },
                leaf: true
            },
            {
                data: {
                    heads: 'Total Amount',
                    atRate: '0.00',
                    totalAmount: '70,00,000'
                },
                leaf: true
            },
            {
                data: {
                    heads: 'Round Off',
                    atRate: '0.00',
                    totalAmount: '0.00'
                },
                leaf: true
            },
            {
                data: {
                    heads: 'Net Amount',
                    atRate: '0.00',
                    totalAmount: '70,00,000'
                },
                leaf: true
            }
        ]
    },

];

export const summaryTreeNodes = [
    {
        data: {
            heads: 'Other Charges',
            amount: '70,00,000',
            cgst: '',
            sgst: '',
            igst: '',
            totalAmount: ''
        },
        children: [
            {
                data: {
                    heads: 'Car Parking',
                    amount: '70,00,000',
                    cgst: '',
                    sgst: '',
                    igst: '',
                    totalAmount: '80,00,000'
                },
                leaf: true
            },
            {
                data: {
                    heads: 'Power Backup',
                    amount: '70,00,000',
                    cgst: '',
                    sgst: '',
                    igst: '',
                    totalAmount: '80,00,000'
                },
                leaf: true
            }
        ]
    },

];


export interface UsersCategory {
    name: string;
    items: any[];
}

export interface Users {
    name: string;
    value: any;
}

